export const channels = [
  {
    slug: 'entertainment',
    name: '娱乐爆料',
    icon: 'ri-mic-line',
    summary: '追踪影视综艺片场动态、艺人合作内幕与活动幕后，用可核实的时间线还原事件走向。',
    tags: ['综艺内幕', '片场见闻', '活动幕后'],
    cadence: '每日更新',
    volume: 1286,
    tone: 'primary',
  },
  {
    slug: 'tech',
    name: '科技内幕',
    icon: 'ri-cpu-line',
    summary: '聚焦数码产品、人工智能应用与互联网平台的规则变化，拆解宣传口径与实际体验的差距。',
    tags: ['数码评测', 'AI 观察', '平台规则'],
    cadence: '每日更新',
    volume: 964,
    tone: 'accent',
  },
  {
    slug: 'finance',
    name: '财经揭密',
    icon: 'ri-line-chart-line',
    summary: '关注上市公司经营动向、资本运作细节与行业财报异动，把复杂数字讲成看得懂的故事。',
    tags: ['公司观察', '资本动向', '财报解读'],
    cadence: '工作日更新',
    volume: 712,
    tone: 'secondary',
  },
  {
    slug: 'society',
    name: '社会民生',
    icon: 'ri-community-line',
    summary: '记录城市治理、公共服务与身边真实事件，从当事人的视角出发呈现完整经过。',
    tags: ['城市观察', '公共服务', '身边事件'],
    cadence: '每日更新',
    volume: 1542,
    tone: 'primary',
  },
  {
    slug: 'consumer',
    name: '消费维权',
    icon: 'ri-shield-check-line',
    summary: '整理价格套路、售后纠纷与虚假宣传案例，附上可操作的投诉路径与沟通话术。',
    tags: ['价格套路', '售后纠纷', '虚假宣传'],
    cadence: '每日更新',
    volume: 1830,
    tone: 'accent',
  },
  {
    slug: 'workplace',
    name: '职场内幕',
    icon: 'ri-briefcase-line',
    summary: '聊招聘话术、加班文化与薪酬结构，帮你在入职前看清岗位背后的真实样貌。',
    tags: ['招聘陷阱', '加班文化', '薪酬真相'],
    cadence: '每周更新',
    volume: 623,
    tone: 'secondary',
  },
  {
    slug: 'auto',
    name: '汽车真相',
    icon: 'ri-roadster-line',
    summary: '针对参数宣传、交付质量与售后响应做横向对比，让选车决策少踩一个坑。',
    tags: ['参数疑云', '售后问题', '新能源'],
    cadence: '每周更新',
    volume: 498,
    tone: 'primary',
  },
  {
    slug: 'estate',
    name: '房产观察',
    icon: 'ri-building-2-line',
    summary: '梳理楼盘质量、交付纠纷与中介套路，用真实案例说明合同里容易被忽略的细节。',
    tags: ['楼盘质量', '交付纠纷', '中介套路'],
    cadence: '每周更新',
    volume: 431,
    tone: 'secondary',
  },
  {
    slug: 'education',
    name: '教育真相',
    icon: 'ri-book-open-line',
    summary: '关注培训退费、招生宣传与校园现象，还原家长和学生真正关心的问题。',
    tags: ['培训退费', '招生宣传', '校园现象'],
    cadence: '每周更新',
    volume: 587,
    tone: 'accent',
  },
  {
    slug: 'health',
    name: '健康真相',
    icon: 'ri-heart-pulse-line',
    summary: '围绕保健品、医美与食品添加，用通俗语言解释成分与宣传之间的关系。',
    tags: ['保健品', '医美观察', '食品添加'],
    cadence: '每周更新',
    volume: 656,
    tone: 'primary',
  },
];

export const channelTones = ['primary', 'accent', 'secondary'] as const;